import React, { useEffect, useState } from "react";
import Layout from "../components/layout";
import "../index.css";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";

const History = () => {
  const Navigate = useNavigate();

  const isAfl = useSelector((state) => state.user.user?.type === "Afl");
  const isAdmin = useSelector((state) => state.user.user?.type === "Admin");
  const isUser = useSelector((state) => state.user.user?.type === "User");
  const [history, setHistory] = useState([]);
  const [filteredHistory, setFilteredHistory] = useState([]);
  const [filters, setFilters] = useState({
    description: "",
    category: "",
    societe: "",
    addresse: "",
    agent: "",
    date: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Number of items per page

  useEffect(() => {
    const getHistory = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/auth/history/other`,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
            method: "POST",
          }
        );

        const data = await response.json();
        if (data.success) {
          setHistory(data.Result);
          console.log("HISTORY: ", history);
          setFilteredHistory(data.Result);
        } else {
          if (data.message === "NOT AUTHORIZED") {
            toast.error("Token expired! Redirecting to login");
            localStorage.clear();
            Navigate("/login");
          } else {
            toast.error(data.message || "Failed to fetch history.");
          }
        }
      } catch (error) {
        console.error("Error fetching history:", error);
      }
    };

    getHistory();
  }, []);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));
  };

  useEffect(() => {
    const applyFilters = () => {
      const filtered = history.filter((item) => {
        // Parse and validate entryDate
        const entryDate = new Date(item.entry_time);
        const formattedEntryDate = isNaN(entryDate.getTime())
          ? ""
          : entryDate.toISOString().slice(0, 10);

        // Convert type for filtering
        const typeToDisplay = item.category.includes("Scan")
          ? "Scan"
          : item.category;

        return (
          (filters.description === "" ||
            `${item.description}`
              .toLowerCase()
              .includes(filters.description.toLowerCase())) &&
          (filters.category === "" ||
            typeToDisplay.toLowerCase() === filters.category.toLowerCase()) &&
          (filters.societe === "" ||
            item.societe
              .toLowerCase()
              .includes(filters.societe.toLowerCase())) &&
          (filters.addresse === "" ||
            item.addresse
              .toLowerCase()
              .includes(filters.addresse.toLowerCase())) &&
          (filters.agent === "" ||
            `${item.prise_en_charge_noms}`
              .toLowerCase()
              .includes(filters.agent.toLowerCase())) &&
          (filters.date === "" ||
            (formattedEntryDate && formattedEntryDate === filters.date))
        );
      });
      setFilteredHistory(filtered);
      setCurrentPage(1); // Reset to the first page when a filter is applied
    };

    applyFilters();
  }, [filters, history]);

  // Calculate pagination data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredHistory.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredHistory.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const exportToCSV = () => {
    const csvData = filteredHistory.map((row) => ({
      noms: row.noms,
      type: row.category.includes("Scan") ? "Scan" : row.category,
      heure_d_entree: row.entry_time
        ? `${new Date(row.entry_time).toLocaleDateString()} ${new Date(
            row.entry_time
          ).toLocaleTimeString()}`
        : "N/A",
      heure_de_sortie: row.exit_time
        ? `${new Date(row.exit_time).toLocaleDateString()} ${new Date(
            row.exit_time
          ).toLocaleTimeString()}`
        : "N/A",
      societe: row.societe,
      addresse: row.addresse,
      agent: row.prise_en_charge_noms,
    }));

    const csvHeader = [
      "Noms",
      "Type",
      "Heure d'entree",
      "Description",
      "Societe",
      "Adresse",
      "Agent d'acceuil",
    ];

    const csvRows = [
      csvHeader.join(","),
      ...csvData.map((row) => Object.values(row).join(",")),
    ];

    const csvContent = "data:text/csv;charset=utf-8," + csvRows.join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "history.csv");
    document.body.appendChild(link);
    link.click();
  };

  return (
    <Layout>
      <div className="px-5 mt-3">
        <div className="d-flex justify-content-center">
          <h3 className="page-title">Historique</h3>
        </div>
        <div className="mt-3">
          <div className="row justify-content-start mb-3">
            <div className="col-12 col-sm-6 col-md-4 category">
              Total lignes: {filteredHistory.length}
            </div>
          </div>
          <div className="row justify-content-between mb-3">
            <div className="col-12 col-sm-6 col-md-4">
              <button
                onClick={exportToCSV}
                style={{ backgroundColor: "#AF47E8" }}
                className="px-3 btn btn-primary "
              >
                Exporter en CSV
              </button>
            </div>
            <div className="col-12 col-sm-6 col-md-4">
              <input
                type="date"
                name="date"
                value={filters.date}
                onChange={handleFilterChange}
                className="form-control"
              />
            </div>
          </div>

          <table className="table mt-3">
            <thead>
              <tr>
                <th className="category">Catégorie</th>
                <th className="category">Noms</th>
                <th className="category">Crée le</th>
                <th className="category">Description</th>
                {(isAdmin || isUser) && <th className="category">Addresse</th>}
                <th className="category">Site</th>
                <th className="category">Utilisateur</th>
              </tr>

              <tr>
                <th>
                  <select
                    name="category"
                    value={filters.category}
                    onChange={handleFilterChange}
                    className="form-control"
                  >
                    <option value="">Category</option>
                    {Array.from(
                      new Set(
                        history.map((item) =>
                          item.category.includes("Scan")
                            ? "Scan"
                            : item.category
                        )
                      )
                    ).map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </th>
                <th>
                  <input
                    type="text"
                    name="noms"
                    placeholder="Noms"
                    value={filters.noms}
                    onChange={handleFilterChange}
                    className="form-control"
                  />
                </th>
                <th></th>
                <th></th>
                <th>
                  <input
                    type="text"
                    name="description"
                    placeholder="Societe"
                    value={filters.description}
                    onChange={handleFilterChange}
                    className="form-control"
                  />
                </th>

                <th>
                  <input
                    type="text"
                    name="addresse"
                    placeholder="Site"
                    value={filters.addresse}
                    onChange={handleFilterChange}
                    className="form-control"
                  />
                </th>
                <th>
                  <input
                    type="text"
                    name="agent"
                    placeholder="Agent"
                    value={filters.agent}
                    onChange={handleFilterChange}
                    className="form-control"
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((e, index) => (
                <tr key={index}>
                  <td>{e.category.includes("Scan") ? "Scan" : e.category}</td>
                  <td>{e.noms ? e.noms : "N/A"}</td>
                  <td>
                    {new Date(e.entry_time).toLocaleString("fr-FR", {
                      timeZone: "UTC",
                    })}
                  </td>

                  <td>
                    {e.category && e.category.includes("Scan")
                      ? e.exit_time
                        ? new Date(e.exit_time).toLocaleString()
                        : "N/A"
                      : e.description}
                  </td>
                  <td>
                    {e.category && e.category.includes("Scan")
                      ? e.description
                      : e.societe}
                  </td>
                  <td>{e.societe}</td>
                  <td>{e.prise_en_charge_noms}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <nav>
            <ul className="pagination">
              {Array.from({ length: totalPages }, (_, i) => (
                <li
                  key={i}
                  className={`page-item ${
                    i + 1 === currentPage ? "active" : ""
                  }`}
                >
                  <button onClick={() => paginate(i + 1)} className="page-link">
                    {i + 1}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </Layout>
  );
};

export default History;
